import { Fade, styled } from '@mui/material';
import { injectTSDI } from '@tools/tsdi';
import { observer } from 'mobx-react';
import * as React from 'react';

import { SignupStore } from '../../signup-store';
import { stepsContent } from '../../steps-data';

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 350
});

export const StepsContainer = observer(() => {
    const { activeStep } = injectTSDI(SignupStore);

    return (
        <>
            {stepsContent.map((stepData, index) => {
                const Component = stepData.component;
                return (
                    <Fade
                        in={index === activeStep}
                        timeout={500}
                        key={stepData.label}
                        unmountOnExit
                        exit={false}
                    >
                        <Container>
                            <Component />
                        </Container>
                    </Fade>
                );
            })}
        </>
    );
});
